import Vue from 'vue';
import App from './App.vue';
import './register-service-worker';
import VeeValidate from "vee-validate";
import router from './common/router';
import store from './store';
import {
  BootstrapVue,
  IconsPlugin,
  LayoutPlugin,
  FormCheckboxPlugin,
  ToastPlugin
} from "bootstrap-vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import "vue2-editor/dist/vue2-editor.css"
import Multiselect from 'vue-multiselect';
import moment from "moment";
import EnumExtension from './common/enum-extensions';
import { Address } from '@/types/common.type';
import { StripePlugin } from "@vue-stripe/vue-stripe";
import Icon from "@/common/components/icon.vue";

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const VueInputMask = require('vue-inputmask').default;

Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(LayoutPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(ToastPlugin);
Vue.use(VueInputMask);
Vue.use(Loading);
Vue.use(StripePlugin, { pk: `${process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY}` });

Vue.component("icon", Icon);

EnumExtension.registerEnums();

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
  errorBagName: "veeErrors",
  events: 'change|blur'
});

VeeValidate.Validator.extend('verify_password', {
  getMessage: () => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character`,
  validate: (value: string) => {
    const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('verify_phone', {
  getMessage: () => `The phone number is invalid.`,
  validate: (value: string) => {
    const strongRegex = new RegExp("^\\d{10}$");
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('verify_zip', {
  getMessage: () => `The zip code is invalid.`,
  validate: (value: string) => {
    const strongRegex = new RegExp("^[0-9]{5}$");
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend('verify_rate', {
  getMessage: () => `The rate is invalid.`,
  validate: (value: string) => {
    const strongRegex = new RegExp("^[0-9]{1,3}([.][0-9]{0,2})?$");
    return strongRegex.test(value) && parseFloat(value) >= 0;
  }
});

VeeValidate.Validator.extend('verify_time_start', {
  getMessage: () => `Close hours should be after Open hours.`,
  validate: (value: string, otherValue: unknown) => {
    let endTime = otherValue as string;

    if (Array.isArray(otherValue)) {
      endTime = otherValue[0];
    }

    return Boolean(value) && Boolean(endTime) && value < endTime;
  }
});

VeeValidate.Validator.extend('verify_time_end', {
  getMessage: () => `Close hours should be after Open hours.`,
  validate: (value: string, otherValue: unknown) => {
    let startTime = otherValue as string;

    if (Array.isArray(otherValue)) {
      startTime = otherValue[0];
    }
    
    return Boolean(value) && Boolean(startTime) && value > startTime;
  }
});


VeeValidate.Validator.extend('before_time', {
  getMessage: () => `The time_in field must be before the time_out field.`,
  validate: (value: string, otherValue: unknown) => {
    const endValues = otherValue as string[];

    if (!endValues?.length) {
      return false;
    }

    const start = moment(value, 'HH:mm');
    const end = moment(endValues[0], 'HH:mm');

    return start <= end;
  }
});

VeeValidate.Validator.extend('address', {
  getMessage: () => 'Address is invalid.',
  validate: (_: string, value: unknown) => {
    const address = value as Address;
    return Boolean(address) &&
      Boolean(address.address1) &&
      Boolean(address.city) &&
      Boolean(address.state) &&
      Boolean(address.zipCode);
  }
});

VeeValidate.Validator.extend('monetary_range', {
  getMessage: () => 'Monetary range is invalid.',
  validate: (value: number, arr: unknown) => {
    const values = arr as string[];
    return Boolean(arr) && value < parseInt(values[0]);
  }
});

VeeValidate.Validator.extend('monetary', {
  getMessage: () => 'Monetary value is invalid.',
  validate: (_: number, otherValue: unknown) => {
    return (otherValue as number[])[0] > 0;
  }
});

Vue.component("loading", Loading);
Vue.component('multiselect', Multiselect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
